import { makeStyles } from '@mui/styles'

export default makeStyles({
  button: {
    '&&': {
      padding: '0',
    },
  },
})
